@use 'sass:map';
@import '@helsenorge/designsystem-react/scss/spacers';
@import '@helsenorge/designsystem-react/scss/breakpoints';

.chat-card {
  width: 100%;
  height: fit-content;
  max-width: 25.68rem;
  background: #7d5185;
  color: #fff;
  padding: 2.125rem 2.3rem 2.3rem 2rem;
  border-radius: 10px;

  &:nth-child(even) {
    background: #2a527b;
  }

  @media (max-width: map.get($grid-breakpoints, md)) {
    padding: 1.9rem 2.13rem 2.13rem 1.84rem;
  }

  &__header {
    &__open-closed-text {
      font-size: 1rem;
      line-height: 1.3rem;
      margin: 0;
      font-weight: 400;

      &--bold {
        font-weight: 600;
      }

      margin-bottom: 1.56rem;
    }

    &__anchor-title {
      color: #fff;
      font-size: 1.5rem;
      font-weight: 400;
      line-height: 2.25rem;
      text-decoration: underline;

      &:hover,
      &:focus {
        font-weight: 600;
      }

      &:focus {
        outline: none;
      }
    }

    &__topic-wrapper {
      display: flex;
      flex-wrap: wrap;
      gap: 0.8rem;
      margin-top: 0.87rem;
    }

    &__topic {
      background: #fff;
      color: #000;
      padding: 0.0625rem 0.625rem;
      border-radius: 5px;
      font-size: 0.75rem;
      font-weight: 400;
      line-height: 1.125rem;
    }
  }

  &__content {
    margin: 1.168rem 0 1.5rem;
    padding-top: 1.137rem;
    border-top: 0.5px solid #fff;
  }

  &__tab-list {
    display: flex;
    flex-wrap: wrap;
    column-gap: 0.625rem;
    margin-bottom: 1.168rem;
  }

  &__tab-button {
    cursor: pointer;
    font-size: 1rem;
    color: #fff;
    background: transparent;
    padding: 0.75rem 0.625rem;
    border: none;
    border-bottom: 2px solid transparent;

    @media (max-width: map.get($grid-breakpoints, md)) {
      font-size: 0.92rem;
      padding-left: 0.4rem;
      padding-right: 0.4rem;
    }

    &--active,
    &:hover,
    &:focus {
      font-weight: 600;
    }

    &--active,
    &:focus {
      border-bottom-color: #fff;
    }

    &:focus {
      outline: none;
    }
  }

  &__tab-content {
    display: none;
    min-height: 6rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5rem;

    &--active {
      display: block;
    }
  }

  &__content-text {
    margin: 0;
  }

  &__contact-wrapper {
    display: flex;
    column-gap: 2rem;
  }

  &__contact-button {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 4.56rem;
    height: 4.56rem;
    border-radius: 100px;
    border: none;
    background: #fff;

    &:hover,
    &:focus {
      box-shadow: 0 0 5px 3px #fff;
      outline: 1px solid #fff;
    }
  }

  &__dl {
    display: grid;
    grid-template-columns: min-content auto;
    gap: 0.4rem 2.4rem;

    dt,
    dd {
      margin: 0;
    }
  }
}

.error {
  color: #fff;
  font-family: Avenir, Montserrat, Poppins, serif;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 2.25rem;

  @media (max-width: map.get($grid-breakpoints, md)) {
    font-size: 1rem;
    line-height: 1.3rem;
  }
}
